import { render, staticRenderFns } from "./Gestantes.vue?vue&type=template&id=1efa109c"
import script from "./Gestantes.vue?vue&type=script&lang=js"
export * from "./Gestantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports